export default __webpack_public_path__ + "static/media/jumbotron.a96e5d55.png";